/**
 * Validates if the payment method is a credit card.
 *
 * @param paymentMethod object with payment method data (credit card or echeck)
 * @returns {boolean} true if paymentMethod is a credit card, false otherwise
 */
export const isCreditCard = paymentMethod =>
  paymentMethod?.paymentMethodType === 'CREDIT_CARD';

/**
 * Determines if the given payment method is an Apple Pay wallet.
 *
 * @param paymentMethod The payment method object to check.
 * @returns {boolean} True if the payment method is an Apple Pay wallet, otherwise false.
 */
export const isApplePay = paymentMethod =>
  paymentMethod?.paymentMethodType === 'WALLET' &&
  paymentMethod?.wallet?.walletType === 'APPLE_PAY';
